var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u533A\\u5757",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-569.000000, -455.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tishi",
    transform: "translate(569.000000, 455.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,0.875 C10.3824219,0.875 13.125,3.61757813 13.125,7 C13.125,10.3824219 10.3824219,13.125 7,13.125 C3.61757813,13.125 0.875,10.3824219 0.875,7 C0.875,3.61757813 3.61757813,0.875 7,0.875 Z M7,1.9140625 C4.19179688,1.9140625 1.9140625,4.19179688 1.9140625,7 C1.9140625,9.80820312 4.19179688,12.0859375 7,12.0859375 C9.80820312,12.0859375 12.0859375,9.80820312 12.0859375,7 C12.0859375,4.19179688 9.80820312,1.9140625 7,1.9140625 Z M7,9.4609375 C7.30203072,9.4609375 7.546875,9.70578178 7.546875,10.0078125 C7.546875,10.3098432 7.30203072,10.5546875 7,10.5546875 C6.69796928,10.5546875 6.453125,10.3098432 6.453125,10.0078125 C6.453125,9.70578178 6.69796928,9.4609375 7,9.4609375 Z M7,3.7734375 C7.57421875,3.7734375 8.115625,3.9703125 8.52578125,4.32988281 C8.95234375,4.703125 9.1875,5.20488281 9.18613874,5.7421875 C9.18613874,6.53242188 8.66523437,7.24335937 7.85859375,7.55371094 C7.63728027,7.63864746 7.47981873,7.83768005 7.44391136,8.0665451 L7.43613281,8.16621094 L7.43613281,8.4765625 C7.43613281,8.52167969 7.40844727,8.56064453 7.36922607,8.57730713 L7.32675781,8.5859375 L6.67050781,8.5859375 C6.62539062,8.5859375 6.58642578,8.55825195 6.56976318,8.51903076 L6.56113281,8.4765625 L6.56113281,8.18261719 C6.56113281,7.86679687 6.65410156,7.55507813 6.83320312,7.2953125 C7.00957031,7.04101562 7.25566406,6.846875 7.54550781,6.73613281 C8.01171875,6.55703125 8.3125,6.16738281 8.3125,5.7421875 C8.3125,5.13925781 7.72324219,4.6484375 7,4.6484375 C6.32196045,4.6484375 5.7616806,5.07982254 5.69429421,5.63054442 L5.6875,5.7421875 L5.6875,5.84609375 C5.6875,5.89121094 5.65981445,5.93017578 5.62059326,5.94683838 L5.578125,5.95546875 L4.921875,5.95546875 C4.87675781,5.95546875 4.83779297,5.9277832 4.82113037,5.88856201 L4.8125,5.84609375 L4.8125,5.7421875 C4.8125,5.20488281 5.04765625,4.703125 5.47421875,4.32988281 C5.884375,3.97167969 6.42578125,3.7734375 7,3.7734375 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#999999"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.e7b0be44.svg";
export { ForwardRef as ReactComponent };